// eslint-disable-next-line wandb/no-deprecated-imports
import {Modal} from 'semantic-ui-react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const DeleteModal = styled(Modal)`
  margin: 0;
`;
DeleteModal.displayName = 'S.DeleteModal';

export const ModalTitle = styled.div`
  font-size: 20pt;
  font-weight: bold;
  line-height: 0;
`;
ModalTitle.displayName = 'S.ModalTitle';

export const ModalContent = styled.div`
  margin-top: 0;
`;
ModalContent.displayName = 'S.ModalContent';
